module.exports = __webpack_public_path__ + "static/media/pm_poster.fa5806d2.jpg";